import { useTranslation } from "react-i18next";
import { FaChevronLeft } from "react-icons/fa6";
import Button from "../../../components/buttons/button";
import { useFormik } from "formik";
import TextInput from "../../../components/inputs/textInput";
import Select from "../../../components/select/select";
import { useOptions } from "../../../components/hooks/useOptionsHook";
import TextArea from "../../../components/inputs/textArea";
import FileInput from "./FileInput";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { Fragment } from "react";

const EditProduct = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const validationSchema = yup.object({
    name: yup.string().required(t("required")),
    category: yup.string().required(t("required")),
    price: yup.string().required(t("required")),
    stock: yup.string().required(t("required")),
    status: yup.number().required(t("required")),
    desc: yup.string().required(t("required")),
  });
  const formik = useFormik({
    initialValues: {
      name: "تيشيرت رياضي",
      category: "",
      price: "250",
      stock: "15",
      status: "",
      desc: "تيشيرت قطن عالي الجودة مناسب للتدريب",
      photos: ["https://placehold.co/400", "https://placehold.co/300", null],
    },
    validationSchema,
    onSubmit: (values) => {
      console.log(values);
    },
  });
  const { memberShipTypeOptions } = useOptions();
  const handleFileChange = (file, i) => {
    const files = [...formik.values.photos];
    files[i] = file;

    if (i === files.length - 1 && file) {
      files.push(null);
    }

    formik.setFieldValue("photos", files);
  };
  const handleRemoveFile = (i) => {
    const files = [...formik.values.photos];
    files.splice(i, 1); // remove the file at index
    formik.setFieldValue("photos", files);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="flex items-center gap-4 my-5">
        <h1
          onClick={() => navigate("/store")}
          className="text-lg font-bold capitalize cursor-pointer md:text-2xl text-primary"
        >
          {t("store")}
        </h1>
        <FaChevronLeft className="ltr:rotate-180" />
        <p className="font-bold capitalize">{t("editProduct")}</p>
      </div>

      <article className="px-6 py-8 space-y-4 border border-white rounded-xl">
        <h1 className="my-4 text-lg font-bold capitalize md:text-2xl">
          {t("editProduct")}
        </h1>
        <div className="inputs">
          <TextInput formik={formik} label={t("productName")} name={"name"} />
          <Select
            options={memberShipTypeOptions}
            formik={formik}
            label={t("category1")}
            name={"category"}
          />
        </div>
        <div className="inputs">
          <TextInput formik={formik} label={t("price")} name={"price"} />
          <TextInput formik={formik} label={t("quantityInStock")} name={"stock"} />
        </div>

        <div className="inputs">
          <Select
            options={memberShipTypeOptions}
            formik={formik}
            label={t("status")}
            name={"status"}
          />
        </div>
        <div>
          <h2 className="text-primary">{t("productPics")}</h2>

          <section className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
            {formik.values.photos.map((photo, i) => (
              <Fragment key={Math.random() * 999}>
                <FileInput
                  id={`photo-${i}`}
                  index={i}
                  handleFileChange={handleFileChange}
                  handleRemoveFile={handleRemoveFile}
                  file={photo}
                />
              </Fragment>
            ))}
          </section>
        </div>
        <div className="inputs">
          <TextArea formik={formik} label={t("shortDesc")} name={"desc"} />
        </div>
        <div className="flex items-center justify-end gap-2">
          <Button
            className={"bg-primary w-[150px] flex justify-center text-black py-3"}
          >
            {t("save")}
          </Button>
          <Button
            onClick={() => {
              navigate("/store");
            }}
            className={"border border-white text-white flex justify-center py-3"}
          >
            {t("cancel")}
          </Button>
        </div>
      </article>
    </form>
  );
};

export default EditProduct;
